import { Component, OnInit, Input, HostListener, ElementRef, ViewChild, ViewChildren, QueryList, Renderer2, Output, EventEmitter, TemplateRef } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { CreateModel, AnswerModel, QuestionnaireModel, QuestElement, QuestPage, Option, FilterMedia, QuestGroup, GapFill, ParamsMedia, ModeQuestion, QuestPropFilter, QResult } from '../../models';
import { HttpService, CoreService } from '../../services';
import { ToastService } from '../../toast';
import { DialogService } from '../../dialog';
import { TagComponent } from '../../tag';
import { QuestionnaireService } from '../questionnaire.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
declare var $: any;

declare var require: any;
const ClassicEditor: any = require('../../../../app-queoval/src/assets/ckeditor5/build/ckeditor');

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'q-create-questionnaire',
  templateUrl: './createQuestionnaire.component.html',
  styleUrls: ['../questionnaire.component.css']
})
export class CreateQuestionnaireComponent implements OnInit {

  // #region constructor
  constructor(
    protected indParam: CoreService,
    protected activatedRouter: ActivatedRoute,
    protected router: Router,
    protected elementHtml: ElementRef,
    protected http: HttpService,
    protected dialogservice: DialogService,
    protected toastservice: ToastService,
    protected renderer: Renderer2,
    protected questionnaireService: QuestionnaireService,
    private modalService: NgbModal
  ) { }
  // #endregion

  // #region Variable globale
  model: string;
  modelQuestionnaire: CreateModel = new CreateModel;
  answerModel: AnswerModel = new AnswerModel;
  questionnaire: QuestionnaireModel = new QuestionnaireModel;
  elementIndex: number = 0;
  pageIndex: number = 0;
  deletedElement: Array<string> = new Array<string>();
  elements: QuestElement[] | null;
  newPage: QuestPage;
  pageCount: number;
  pageAdded: boolean;
  screenWidht: number;
  elementCount: number = 0;
  modelName: string;
  pulse: boolean = true;
  modeQuest: boolean;
  menuPosition: number;
  totalPoint: number;
  nbQuesiton: number = 0;
  nbFilter: number = 0;
  get Top(): number {
    let idQuest: string = this.idQuestionnaire ?? '';
    return $(`#Questionnaire-wrapper-${idQuest}`).offset().top;
  };
  idQuestionnaire: string;
  ModeQuestion = ModeQuestion;

  public ckConfigDesc: any;
  public ckConfigMsgFin: any;
  public ckConfigIndice: any;
  public ckConfigCommentaire: any;
  public Editor: any = ClassicEditor;

  // Media
  elementImg: QuestElement;
  optionImg: Option | null;
  filterMedia: FilterMedia = new FilterMedia();

  @ViewChild('openModalMedia', { static: false }) openModalMedia: ElementRef;
  @ViewChild('cloneModalMedia', { static: false }) closeModalMedia: ElementRef;

  @ViewChild(TagComponent, { static: false }) tagComp: TagComponent;

  //@ViewChildren('page') page: QueryList<ElementRef>;
  //@ViewChildren('element') element: QueryList<ElementRef>;
  @ViewChildren('interactable') interactable: QueryList<ElementRef>;

  @ViewChild('menu', { static: false }) menu: ElementRef;

  // affichage du bouton de suppression
  public showDelete: boolean;

  /* modal de suppression */
  @ViewChild('ModalDeleteValidation') ModalDeleteValidation: TemplateRef<HTMLTemplateElement>;

  // Texte de confirmation de suppression
  public txtConfirmDelete: string;

  // #endregion

  // #region Listener
  // get screen size on window resize
  @HostListener('window:resize', ['$event'])
  onResize(event: any): void {
    this.screenWidht = screen.width;
  }

  // get scroll position
  @HostListener('window:scroll', ['$event'])
  repositionningMenu(event: any): void {
    const scrollPositionTop: number = (window.pageYOffset || this.elementHtml.nativeElement.scrollTop) - (this.elementHtml.nativeElement.clientTop || 0);
    const ScrollPositionBot: number = scrollPositionTop + window.innerHeight;
    const margin = 10;

    if (scrollPositionTop >= this.menuPosition + this.Top) {
      this.renderer.setStyle(this.menu.nativeElement, 'top', `${scrollPositionTop - this.Top + margin}px`);
      this.renderer.setStyle(this.menu.nativeElement, 'transition', 'all 0s');
    }
    if (ScrollPositionBot <= this.menuPosition + this.menu.nativeElement.clientHeight + this.Top) {
      this.renderer.setStyle(this.menu.nativeElement, 'top', `${ScrollPositionBot - this.menu.nativeElement.clientHeight - this.Top - margin}px `);
      this.renderer.setStyle(this.menu.nativeElement, 'transition', 'all 0s');
    }

    if (scrollPositionTop < this.menuPosition + this.Top && ScrollPositionBot > this.menuPosition + this.menu.nativeElement.clientHeight + this.Top) {
      this.renderer.setStyle(this.menu.nativeElement, 'top', `${this.menuPosition}px`);
      this.renderer.setStyle(this.menu.nativeElement, 'transition', 'all .3s cubic-bezier(0.4,0.0,0.2,1)');
    }

  }


  // Check click outside
  private wasInside = false;
  @HostListener('click')
  clickInside() {
    this.wasInside = true;
  }

  @HostListener('document:click')
  clickout() {
    if (!this.wasInside) {
      this.closeCustomSelect(null);
    }
    this.wasInside = false;
  }



  @Input()
  set CreateModel(value: CreateModel) {
    if (value != null) {
      console.log(value);
      this.dialogservice.showSplash(true);
      this.modelQuestionnaire = value;
      // this.elementCount = this.modelQuestionnaire.nbElement;
      this.questionnaire = this.modelQuestionnaire.questionnaireModel;
      this.answerModel = new AnswerModel();
      this.answerModel.questionnaireModel = new QuestionnaireModel();
      this.answerModel.questionnaireModel = this.questionnaire;
      this.initView();
    }
  }

  @Input()
  set decalageTop(value: number) {
    if (value != null) {
      // this.Top = value;
    }
  }

  @Input()
  set ModelIdent(value: string) {
    if (!(value == null || value === undefined)) {
      this.idQuestionnaire = value
      this.loadModel(value);
      //  this.initView();
    }
  }

  /**
 * Questionnaire envoyé au composant parent (si besoin d'actualiser par exemple)
 */
  @Output() SendQuest: EventEmitter<QuestionnaireModel> = new EventEmitter<QuestionnaireModel>();

  // #endregion

  // #region Life Cycle

  ngOnInit(): void {

    this.questionnaireService.getNavigationData().subscribe(data => { if (data) this.loadModel(data); });

    this.manageCkEditorConfig();
    this.dialogservice.showSplash(true);
    this.screenWidht = screen.width;
    this.filterMedia.byType.document = false;
    //this.Top = $('#Questionnaire-wrapper').offset().top;
    $('body').click(this.closeCustomSelect(null));

    this.showDelete = false;
  }

  initView(): void {
    setTimeout(() => {
      // this.indParam.getTrad();
      // set initial menu position



      this.getMaxNote();
      this.menuPosition = this.elementHtml.nativeElement.querySelector('.headerQuestionnaire').offsetTop;
      this.renderer.setStyle(this.menu.nativeElement, 'top', `${this.menuPosition}px`);
      this.initTimerSelect();
      // this.elementCount = this.elementHtml.nativeElement.querySelectorAll(`li[class*='elementAnimation']`).length;

      // masquage du bouton de suppression
      this.showDelete = false;
    }, 0);
    //  this.dialogservice.showSplash(false);
  }

  callOnLastIteration(last: boolean): void {
    if (last) {
      this.dialogservice.showSplash(false);
    }
  }
  // #endregion

  // #region public function
  // #region Side Menu
  // Move side menu and get current context
  moveMenu(pElementIndex: number, pPageIndex: number, pIsActive: boolean = false): void {
    if (pIsActive) {
      return;
    }

    if (this.menu)
      this.renderer.setStyle(this.menu.nativeElement, 'transition', 'all .3s cubic-bezier(0.4,0.0,0.2,1)');

    this.initDnD();
    // Get current context
    this.elementIndex = pElementIndex;
    this.pageIndex = pPageIndex;

    if (!this.questionnaire.pagination[this.pageIndex]) {
      this.addPage();
    } else {
      this.elements = this.questionnaire.pagination[this.pageIndex].elements;
      const idElement: number = this.questionnaire.pagination[this.pageIndex].elements[this.elementIndex].idEl;

      if (this.pulse) {
        this.pulse = false;
        if (this.elementHtml.nativeElement.querySelector('.pulsebtn')) {
          this.elementHtml.nativeElement.querySelector('.pulsebtn').classList.remove('pulsebtn');
        }
      }

      // activates the selected element to change its style
      this.questionnaire.pagination.forEach((Page: QuestPage) => {
        Page.IsActive = false;
        Page.elements.forEach((Element: QuestElement) => {
          if (Element.idEl === idElement) {
            Element.IsActive = true;
          } else {
            Element.IsActive = false;
          }
        });
      });

      setTimeout(() => {
        // get element top position
        const id: string = `#Element${idElement}`;
        this.menuPosition = this.getNativeElement(id).getBoundingClientRect().top + window.pageYOffset - this.Top;

        // move menu to destination
        this.renderer.setStyle(this.menu.nativeElement, 'top', `${this.menuPosition}px`);

        // scroll to new page
        // if (this.pageAdded) {
        window.scrollTo(0, (this.menuPosition - 100));
        this.pageAdded = false;
        // }
      }, 1);
    }

    this.showDelete = true;
  }



  moveMenuPage(pPageIndex: number, pElementType?: string): void {
    this.reorderPage();
    this.renderer.setStyle(this.menu.nativeElement, 'transition', 'all .3s cubic-bezier(0.4,0.0,0.2,1)');
    this.initDnD();

    // Get current context
    this.pageIndex = pPageIndex;
    this.elements = this.questionnaire.pagination[this.pageIndex].elements;
    this.elementIndex = -1;

    // Deactivates all element
    this.questionnaire.pagination.forEach((Page: QuestPage) => {
      Page.IsActive = false;
      Page.elements.forEach((Element: QuestElement) => {
        Element.IsActive = false;
      });
    });
    this.questionnaire.pagination[this.pageIndex].IsActive = true;

    if (pElementType !== undefined) {
      this.moveMenu(0, this.pageIndex);
    } else {
      setTimeout(() => {
        // get page top position
        const id: string = `#Page${pPageIndex}`;
        this.menuPosition = this.getNativeElement(id).getBoundingClientRect().top + window.pageYOffset - this.Top;
        // move menu to destination
        this.renderer.setStyle(this.menu.nativeElement, 'top', `${this.menuPosition}px`);

        // scroll to new page     
        window.scrollTo(0, (this.menuPosition - 100));
      }, 1);
    }
    this.showDelete = true;
  }
  // #endregion

  // #region Page
  addPage(pElementType?: string): void {
    // get number of page
    this.pageCount = this.elementHtml.nativeElement.querySelectorAll(`div[id*='page']`).length;
    // create new page
    this.newPage = new QuestPage;
    this.newPage.numPage = (+this.pageCount) + 1;
    this.newPage.elements = new Array<QuestElement>();
    // create new page with base element
    if (pElementType !== undefined) {
      const newElement: QuestElement = new QuestElement;
      newElement.optionType = '-1';
      newElement.type = pElementType;
      if (pElementType === 'text') {
        newElement.required = false;
      }
      this.elementCount++;
      newElement.idEl = this.elementCount;
      this.newPage.elements.push(newElement);
    }
    if (this.questionnaire.pagination.length === 0) {
      this.questionnaire.pagination.push(this.newPage);
      setTimeout(() => {
        this.moveMenuPage(0, pElementType);
      }, 10);
    } else {
      this.pageIndex = (+this.pageIndex) + 1;
      this.questionnaire.pagination.splice(this.pageIndex, 0, this.newPage);
      setTimeout(() => {
        this.moveMenuPage(this.pageIndex, pElementType);
      }, 10);
    }
    this.pageAdded = true;

  }

  deletePage(pIdPage: number): void {

    this.questionnaire.pagination[pIdPage].elements.forEach((e: QuestElement) => {
      this.deletedElement.push(e.ident);
    });
    this.modelQuestionnaire.deletedElement = this.deletedElement;


    this.questionnaire.pagination.splice(pIdPage, 1);
    this.elements = null;
    if (this.pageIndex !== 0) {
      this.pageIndex = pIdPage;
    }
    // get number of page
    this.pageCount = this.elementHtml.nativeElement.querySelectorAll(`div[id*='page']`).length;
    if (this.questionnaire.pagination.length > 0) {
      // move previous page ( next page if first page )
      if (this.pageCount === (+this.pageIndex) + 1) {
        this.pageIndex = this.pageIndex - 1;
      }

      this.moveMenuPage(this.pageIndex);
    } else {
      this.menuPosition = this.elementHtml.nativeElement.querySelector('.headerQuestionnaire').offsetTop;
      this.renderer.setStyle(this.menu.nativeElement, 'top', `${this.menuPosition}px`);
      this.showDelete = false;
    }
  }

  getMaxNote(): void {
    let note: number;
    this.totalPoint = 0;
    this.nbQuesiton = 0;
    this.questionnaire.pagination.forEach((page: QuestPage) => {
      page.elements.forEach((element: QuestElement) => {
        element.maxPoint = element.maxPoint ?? 0;
        note = 0;
        if (element.type === 'question' && element.optionType != "-1") {
          this.nbQuesiton++;
          switch (element.optionType) {

            case 'SATISFACTION':
              note = 5;
              this.totalPoint += note;
              break;

            case 'CHECKLISTE':
            case 'GAPFILL':
              element.options.forEach((option: Option) => {
                if (option.point > 0) {
                  note += Number(option.point);
                }
              });
              if (note > 0) {
                this.totalPoint += Number(note);
              }
              break;
            case 'RADIOLISTE':
              element.options.forEach((option: Option) => {
                if (option.point > note) {
                  note = Number(option.point);
                }
              });
              if (note > 0) {
                this.totalPoint += Number(note);
              }
              break;

            default:
              note = Number(element.maxPoint);
              this.totalPoint += Number(element.maxPoint);
              break;
          }
        }

        element.maxPoint = note;
      });
    });
    this.updateGroupNote();
    if (this.questionnaire.notePassage > this.totalPoint) {
      this.toastservice.showWarningToast('Note de passage supérieur à la note maximal');
    }
  }

  elementMaxNote(element: QuestElement): void {
    //let note: number = 0;
    //if (element.type === 'question') {
    //  this.nbQuesiton++;
    //  if (!(element.optionType === 'CHECKLISTE' || element.optionType === 'RADIOLISTE' || element.optionType === 'GAPFILL')) {
    //    this.totalPoint += Number(element.maxPoint);
    //  } else {
    //    element.options.forEach((option: Option) => {
    //      if (element.optionType === 'CHECKLISTE' || element.optionType === 'GAPFILL') {
    //        if (option.point > 0) {
    //          note += Number(option.point);
    //        }
    //      }
    //      if (element.optionType === 'RADIOLISTE') {
    //        if (option.point > note) {
    //          note = Number(option.point);
    //        }
    //      }
    //    });
    //    if (note > 0) {
    //      this.totalPoint += Number(note);
    //    }
    //  }
    //}
    //element.maxPoint = note;
    //this.updateGroupNote();
  }

  // #endregion

  // #region Element
  addElement(pElementType: string): void {
    // create page if no page exist
    if (this.elements) {
      // add an new elemet to the page
      const newElement: QuestElement = new QuestElement;
      newElement.optionType = '-1';
      newElement.type = pElementType;
      if (pElementType === 'text') {
        newElement.required = false;
      }
      this.elementCount++;
      newElement.idEl = this.elementCount;
      // push instead splice if the page is empty
      if (this.elements.length > 0) {
        if (this.elementIndex != null) {
          this.elements.splice((this.elementIndex + 1), 0, newElement);
          this.moveMenu((this.elementIndex + 1), this.pageIndex);
        } else {
          this.elements.push(newElement);
          this.moveMenu(this.elements.length - 1, this.pageIndex);
        }
      } else {
        this.elements.push(newElement);
        this.moveMenu(0, this.pageIndex);
      }
    } else {
      // create new page
      this.addPage(pElementType);
    }
  }

  /** Ouvrir une modal , la taille dépend du paramètre xl (vrai par default => modal taille q-xxl)
 * 
 * @param Modal la modal qui doit être ouverte
 */
  public openModalConfirmDelete(Modal: any) {
    this.modalService.open(Modal, { centered: true, windowClass: 'qmodalover' });
    // définition du texte de confirmation de suppression
    if (this.elementIndex >= 0) {
      this.txtConfirmDelete = `Etes-vous sûr de vouloir supprimer l'élément `;
    }
    else {
      this.txtConfirmDelete = `Etes-vous sûr de vouloir supprimer la page `;
    }
  }

  deleteElement(): void {
    if (this.elementIndex >= 0) {
      // delete element
      if (this.questionnaire.pagination[this.pageIndex].elements[this.elementIndex].ident !== '0') {
        this.deletedElement.push(this.questionnaire.pagination[this.pageIndex].elements[this.elementIndex].ident);
        this.modelQuestionnaire.deletedElement = this.deletedElement;
      }
      if (this.elements) {
        this.elements.splice(this.elementIndex, 1);
        if (this.elements.length > 0) {
          // move previous element ( next element if first element )
          if (this.elementIndex !== 0) {
            this.elementIndex = (this.elementIndex - 1);
          }
          this.moveMenu(this.elementIndex, this.pageIndex);
        } else {
          // move to parent page if no element left
          this.moveMenuPage(this.pageIndex);
        }
      }
    } else {
      // delete selected page
      this.deletePage(this.pageIndex);
    }
  }
  // #endregion
  // #region Option
  addOption(pParent: any): void {
    // add option to an element
    const choix: Option = new Option;
    pParent.push(choix);
  }

  deleteOption(pParent: any, pIndex: number): void {
    if (this.questionnaire.pagination[this.pageIndex].elements[this.elementIndex].options[pIndex].ident !== '0') {
      this.deletedElement.push(this.questionnaire.pagination[this.pageIndex].elements[this.elementIndex].options[pIndex].ident);
    }
    // delete option to an element
    pParent.splice(pIndex, 1);
  }

  onChangeOption(pOptionType: any, pElement: QuestElement): void {

    // Si l'ancien type de question est un oui/non, on delete des options
    if (pElement.optionType == 'YesNo') {
      this.deletedElement.push(...pElement.options.filter(x => x.ident != '0').map(x => x.ident));   
      pElement.options = new Array<Option>();
    }

    // manage question option type
    pElement.optionType = pOptionType;
    switch (pOptionType) {
      case 'YesNo':
        pElement.options = new Array<Option>();
        const choixOui: Option = new Option;
        choixOui.isCorrectAnswer = true;
        choixOui.text = 'Oui';
        const choixNon: Option = new Option;
        choixNon.isCorrectAnswer = false;
        choixNon.text = 'Non';
        pElement.options.push(choixOui);
        pElement.options.push(choixNon);
        break;
      case 'MATCHING':
      case 'MATCHINGNOTEREPONSE':
        pElement.options.forEach((option: Option) => {
          this.deletedElement.push(option.ident);
        });
        break;
      case 'SATISFACTION':
        pElement.maxPoint = 0;
        pElement.options.forEach((option: Option) => {
          this.deletedElement.push(option.ident);
        });
        const choix: Option = new Option;
        pElement.options = new Array<Option>();
        pElement.options.push(choix);
        break;
      default:
        if (pElement.options.length < 1) {
          const choix: Option = new Option;
          pElement.options.push(choix);
        }
    }
    this.modelQuestionnaire.deletedElement = this.deletedElement;
    this.getMaxNote()
  }

  onChangeCorrectAnswer(pElement: QuestElement, pOption: Option): void {
    // allow only one good answer when the question's type is radioliste
    if (pElement.optionType === 'RADIOLISTENOTEQUESTION' || pElement.optionType === 'YesNo') {
      for (const option of pElement.options) {
        option.isCorrectAnswer = false;
      }
    }
    pOption.isCorrectAnswer = true;
  }

  selectWord(index: number, pElement: QuestElement, pOptionIndex: number): void {
    const splitedText: string[] = pElement.options[pOptionIndex].text.split(' ');
    if (splitedText[index].includes('[') && splitedText[index].includes(']')) {
      splitedText[index] = splitedText[index].slice(1, -1);
    } else {
      splitedText[index] = `[${splitedText[index]}]`;
    }
    pElement.options[pOptionIndex].text = splitedText.join(' ');
    this.generateGapOption(pElement, pOptionIndex);
  }

  generateGapOption(pElement: QuestElement, pOptionIndex: number): void {

    pElement.options[pOptionIndex].gapsFill = new Array<GapFill>();
    const splitedText: string[] = pElement.options[pOptionIndex].text.split(' ');
    splitedText.forEach((word: string) => {
      const GF: GapFill = new GapFill;
      GF.text = word.toLowerCase();
      if (GF.text.includes('[') && GF.text.includes(']')) {
        GF.text = GF.text.slice(1, -1);
      }
      pElement.options[pOptionIndex].gapsFill.push(GF);
    });
  }

  selectedWord(selectedWord: string): string {
    let result: string = ' ';
    if (selectedWord.includes('[') && selectedWord.includes(']')) {
      result = 'activeWord';
    }
    return result;
  }
  // #endregion

  // #region Navigation
  goToVisualisation(): void {
    // redirecting to visualisation page
    this.answerModel.questionnaireModel = new QuestionnaireModel();
    this.answerModel.questionnaireModel = this.questionnaire;
    this.answerModel.nbElement = this.elementCount;
    this.answerModel.readOnly = true;
    this.answerModel.modeQuestionnaire = 'visualisation';
  }

  updateQuestionnaire(): void {
    if (this.QuestIsCorrect()) {
      this.dialogservice.showSplash(true);
      this.getMaxNote();
      this.modelQuestionnaire.questionnaireModel = this.questionnaire;
      this.modelQuestionnaire.deletedElement = this.deletedElement;
      this.modelQuestionnaire.questionnaireModel.noteMax = this.totalPoint;
      this.modelQuestionnaire.questionnaireModel.nbQuestion = this.nbQuesiton;

      this.modelQuestionnaire.Mode = 'send';
      if (this.modelQuestionnaire.questionnaireModel.pagination.length > 0) {
        this.http.postHttp<QResult<CreateModel>>(`${this.indParam.AppParams.UrlQuestionnaireWS}api/Create/`, this.modelQuestionnaire).subscribe((data: QResult<CreateModel>) => {
          this.dialogservice.showSplash(false);
          if (!data.HasError) {
            this.tagComp.saveTag(data.Value.questionnaireModel.ident);
            this.deletedElement = new Array<string>();
            this.questionnaire = data.Value.questionnaireModel;
            // activates the selected element to change its style
            this.questionnaire.pagination.forEach((Page: QuestPage) => {
              Page.IsActive = false;
              Page.elements.forEach((Element: QuestElement) => {
                if (Element.idEl === this.questionnaire.pagination[this.pageIndex].elements[this.elementIndex].idEl) {
                  Element.IsActive = true;
                } else {
                  Element.IsActive = false;
                }
              });
            });

            this.toastservice.showSuccessToast(this.indParam.getTrad('questionnairesaved_QU'));
            this.SendQuest.emit(this.questionnaire);
          } else {
            this.dialogservice.showAlert(data.Error);
          }
        });
      } else {
        this.toastservice.showWarningToast(this.indParam.getTrad('addatleastonequestion_QU'));
        this.dialogservice.showSplash(false);
      }
    }


  }

  goBack(): void {
    this.router.navigate([`../model`], { relativeTo: this.activatedRouter });
    // this.router.navigate(['webform/questionnaire/model']);
  }
  // #endregion

  // #endregion

  // #region Private function
  private initDnD(): void {
    // manage drag and drop
    $(`.sortable`).sortable({
      connectWith: '.sortable',
      handle: '.grip',
      stop: (event: any, ui: any): void => {
        const el: QuestElement | null = this.elements ? this.elements[this.elementIndex] : null;
        if (this.elements) {
          this.elements.splice((this.elementIndex), 1);
        }
        this.pageIndex = ui.item.parent()[0].id;
        if (el) {
          this.questionnaire.pagination[this.pageIndex].elements.splice(ui.item.index(), 0, el);
          this.elements = this.questionnaire.pagination[this.pageIndex].elements;
          const elPosition: number = this.elements.indexOf(el);
          this.moveMenu(elPosition, this.pageIndex);
        }
      }
    });
  }

  private loadModel(pModel: any): void {
    // load model for modification
    this.http.getHttp<QResult<CreateModel>>(`${this.indParam.AppParams.UrlQuestionnaireWS}api/Create/INITDATA/${pModel}/`).subscribe((data: QResult<CreateModel>) => {
      if (!data.HasError) {
        this.questionnaire = data.Value.questionnaireModel;
        this.idQuestionnaire = this.questionnaire.ident;
        this.questionnaire.notePassage = data.Value.questionnaireModel.notePassage ? data.Value.questionnaireModel.notePassage : 0;
        //this.questionnaire.messageFin = data.questionnaireModel.messageFin;
        //this.questionnaire.description = data.questionnaireModel.description;
        //this.questionnaire.pagination = data.questionnaireModel.pagination;
        //this.questionnaire.titre = data.questionnaireModel.titre;
        this.questionnaire.isElearning = data.Value.questionnaireModel.isElearning ? (data.Value.questionnaireModel.isElearning ? true : false) : false;
        //this.questionnaire.questionnaireType = data.questionnaireModel.questionnaireType;
        //this.questionnaire.ident = data.questionnaireModel.ident;
        //this.questionnaire.group = data.questionnaireModel.group;
        //this.questionnaire.certification = data.questionnaireModel.certification;
        this.nbFilter = this.questionnaire.filterBo ? this.questionnaire.filterBo.filter((r: QuestPropFilter) => r.propFilter == true).length : 0;
        let idEl: number = 1;
        this.questionnaire.pagination.forEach((Page: QuestPage) => {
          Page.elements.forEach((Element: QuestElement) => {
            Element.idEl = idEl++;
          });
        });
        this.elementCount = idEl;
        this.modelQuestionnaire.modelName = data.Value.modelName;
        this.modelQuestionnaire.deletedElement = new Array<string>();
        this.initView();

      } else {
        this.dialogservice.showAlert(this.indParam.getTrad('modelcantopen_QU'));
        const rs: CreateModel = data.Value;
      }
    });
  }

  private getNativeElement(idElement: string) {
    // @ts-ignore
    return this.interactable._results.find((el: any) => el.nativeElement.id == idElement.replace('#', '')).nativeElement;
  }
  // #region Groupe

  updateGroupNote(): void {

    this.questionnaire.group.forEach((group: QuestGroup) => {
      group.groupPointMax = 0;
      group.groupElements.forEach((element: QuestElement) => {

        this.questionnaire.pagination.forEach((page: QuestPage) => {
          page.elements.forEach((elem: QuestElement) => {
            if ((element.ident === '0' && element === elem) || (element.ident === elem.ident)) {
              group.groupPointMax += +elem.maxPoint;
            }
          });
        });
      });

      if (group.randomEl > 0) {
        group.groupPointMaxRng = group.randomEl * group.groupPointMax / group.groupElements.length;
        this.totalPoint = this.totalPoint - (group.groupPointMax - group.groupPointMaxRng);
      }
    });




  }

  getGroupStyle(element: QuestElement): any {
    const color: Array<string> = ['#2077B4', '#FF7F0E', '#2DA02C', '#D62728', '#9366BE', '#8C554A', '#E377C3', '#7F7F7F', '#BCBD22', '#17BECF'];
    const index: number = this.questionnaire.group.findIndex((group: QuestGroup): boolean => group.groupName === element.groupName);

    const styles: any = {
      'background-color': color[index % 10]
    };
    return styles;
  }

  addGroup(): void {
    const group: QuestGroup = new QuestGroup();
    this.questionnaire.group.push(group);
  }

  onChangeQuestionGroup(event: any, idPage: number, idElem: number, idGroup: number, nameGroup: string): void {
    // event.stopPropagation();
    if (nameGroup) {
      this.questionnaire.group[idGroup].groupName = nameGroup;

      if (!this.questionnaire.pagination[idPage].elements[idElem].groupName) {

        this.questionnaire.pagination[idPage].elements[idElem].groupName = nameGroup;
        this.questionnaire.pagination[idPage].elements[idElem].groupPoint = this.questionnaire.group[idGroup].groupPoint;

        this.questionnaire.group[idGroup].groupPointMax += +this.questionnaire.pagination[idPage].elements[idElem].maxPoint;

        this.questionnaire.group[idGroup].groupElements.push(this.questionnaire.pagination[idPage].elements[idElem]);

        this.getMaxNote();

      } else {

        this.questionnaire.pagination[idPage].elements[idElem].groupName = '';
        this.questionnaire.pagination[idPage].elements[idElem].groupPoint = 0;

        this.questionnaire.group[idGroup].groupPointMax -= +this.questionnaire.pagination[idPage].elements[idElem].maxPoint;
        const idElement: number = this.questionnaire.group[idGroup].groupElements.findIndex(el => el.ident == this.questionnaire.pagination[idPage].elements[idElem].ident);
        this.questionnaire.group[idGroup].groupElements.splice(idElement, 1);

        if (this.questionnaire.group[idGroup].randomEl > 0 && this.questionnaire.group[idGroup].randomEl > this.questionnaire.group[idGroup].groupElements.length) {
          this.questionnaire.group[idGroup].randomEl--;
          this.getMaxNote();
        }
      }
    } else {
      this.toastservice.showWarningToast('Veuillez donner un nom au groupe');
    }
  }

  changeGroup(idGroup: number): void {
    const groupEl: Array<QuestElement> = this.questionnaire.group[idGroup].groupElements;
    if (groupEl.length > 0) {

      if (this.questionnaire.group[idGroup].randomEl > this.questionnaire.group[idGroup].groupElements.length) {
        this.questionnaire.group[idGroup].randomEl = 0;
        setTimeout(() => { this.questionnaire.group[idGroup].randomEl = this.questionnaire.group[idGroup].groupElements.length }, 0);
      } else {
        this.questionnaire.group[idGroup].randomEl = this.questionnaire.group[idGroup].randomEl;
      }

      this.questionnaire.pagination.forEach((page: QuestPage) => {
        page.elements.filter(el => { return groupEl.some(grpEl => { return el.ident === "0" ? grpEl.idEl == el.idEl : grpEl.ident == el.ident }) }).forEach((el: QuestElement) => {
          el.groupPoint = this.questionnaire.group[idGroup].groupPoint;
          el.groupName = this.questionnaire.group[idGroup].groupName;
          el.groupRandom = Number(this.questionnaire.group[idGroup].randomEl);
        });
      });
      setTimeout(() => {
        this.getMaxNote();
      }, 0);
    }
  }

  toggleRandomGroup(idGroup: number): void {
    this.questionnaire.group[idGroup].isRandom = !this.questionnaire.group[idGroup].isRandom;
    if (!this.questionnaire.group[idGroup].isRandom) {

      const groupEl: Array<QuestElement> = this.questionnaire.group[idGroup].groupElements;
      if (groupEl.length > 0) {
        this.questionnaire.pagination.forEach((page: QuestPage) => {
          page.elements.filter(el => { return groupEl.some(grpEl => { return el.ident === "0" ? grpEl.idEl == el.idEl : grpEl.ident == el.ident }) }).forEach((el: QuestElement) => {
            el.groupRandom = 0;
          });
        });
      }
    }
  }


  showCustomSelect(event: any, id: string): void {
    event.stopPropagation();
    let active: boolean = this.elementHtml.nativeElement.querySelector(id).classList.contains('active')

    this.elementHtml.nativeElement.querySelectorAll('.customSelect').forEach((e: any): any => { if (e.id != id) e.classList.remove('active'); });

    this.elementHtml.nativeElement.querySelector(`${id}focus`).classList.toggle('active');

    if (active) {
      this.elementHtml.nativeElement.querySelector(id).classList.remove('active');
    } else {
      this.elementHtml.nativeElement.querySelector(id).classList.add('active');
    }

  }

  closeCustomSelect(event: any): void {
    this.elementHtml.nativeElement.querySelectorAll('.customSelect').forEach((e: any): any => { e.classList.remove('active'); });
    this.elementHtml.nativeElement.querySelectorAll('.overSelect').forEach((e: any): any => { e.classList.remove('active'); });
  }

  deleteGroup(idGroup: number): void {

    this.questionnaire.group[idGroup].groupElements.forEach((element: QuestElement) => {
      this.questionnaire.pagination.forEach((page: QuestPage) => {
        page.elements.forEach((elem: QuestElement) => {
          if ((element.ident === '0' && element === elem) || (element.ident === elem.ident)) {
            elem.groupPoint = 0;
            elem.groupName = '';
          }
        });
      });
    });
    this.questionnaire.group.splice(idGroup, 1);
  }

  // #endregion

  private reorderPage(): void {
    // rename page with the new right order
    let numPage: number = 1;
    for (const page of this.questionnaire.pagination) {
      page.numPage = numPage;
      numPage++;
    }
  }



  hours: Array<number> = new Array<number>();
  minutes: Array<number> = new Array<number>();
  seconds: Array<number> = new Array<number>();

  @ViewChild('selectHour', { static: false }) selectHour: ElementRef;
  @ViewChild('selectMinute', { static: false }) selectMinute: ElementRef;
  @ViewChild('selectSecond', { static: false }) selectSecond: ElementRef;

  public onChangeTimer() {
    let time: number = 0;


    time += +this.selectHour.nativeElement.value * 3600;
    time += +this.selectMinute.nativeElement.value * 60;
    time += +this.selectSecond.nativeElement.value;

    this.questionnaire.certification.tempsCertification = time;
  }

  private initTimerSelect() {
    for (let hour: number = 0; hour < 24; hour++) {
      this.hours.push(hour);
    }
    for (let min: number = 0; min < 60; min++) {
      this.minutes.push(min);
      this.seconds.push(min);
    }

    setTimeout(() => {
      let totalSeconds = this.questionnaire.certification.tempsCertification;
      if (this.selectHour) {
        this.selectHour.nativeElement.value = Math.floor(totalSeconds / 3600);
        totalSeconds %= 3600;
        this.selectMinute.nativeElement.value = Math.floor(totalSeconds / 60);
        this.selectSecond.nativeElement.value = totalSeconds % 60;
      }
    }, 10);

  }

  /**
   * Fonction qui vérifie si le questionnaire est correct : pas d'intitulé vide / type de question vide / intitulé d'une réponse vide
   */
  private QuestIsCorrect(): boolean {
    let result = true;
    // Parcours des pages
    this.questionnaire.pagination.forEach((Page: QuestPage) => {
      // Parcours des questions
      let numQuest = 0;
      if (Page.elements && Page.elements.length == 0) {
        result = false;
        this.toastservice.showWarningToast(`Page n°${Page.numPage} : Page vide`);
      }
      Page.elements.forEach((element: QuestElement) => {

        numQuest++;
        if (element.text == '') {
          result = false;
          this.toastservice.showWarningToast(`Page n°${Page.numPage} - Question ${numQuest} : Intitulé de la question vide`);
        }
        if (element.type == 'question' && (element.optionType == '' || element.optionType == '-1')) {
          result = false;
          this.toastservice.showWarningToast(`Page n°${Page.numPage} - Question ${numQuest} : Type de question vide`);
        }
        // Parcours des réponses
        //let numRep = 0;
        //element.options.forEach((option: Option) => {
        //  numRep++;
        //  if (option.text == '') {
        //    result = false;
        //    this.toastservice.showWarningToast(`Page n°${Page.numPage} - Question ${numQuest} - Réponse ${numRep} : Intitulé de la réponse vide`);
        //  }

        //});

        // Si c'est un questionnaire de certification -> il ne doit y avoir que des sections "questionnaires"
        if (this.questionnaire.certification && this.questionnaire.certification.isCertification &&  element.type != 'question') {
          result = false;
          this.toastservice.showWarningToast(`Page n°${Page.numPage} : Il n’est pas possible d’enregistrer des titres dans un questionnaire de type certification, veuillez supprimer le titre`);
        }

      });
    });
    return result;
  }

  // #endregion

  // #region Media
  openMedia(element: QuestElement, option: Option | null): void {

    if (!option) {
      this.optionImg = null;
      this.elementImg = element;
    } else {
      this.optionImg = option;
      this.elementImg = element;
    }
    this.openModalMedia.nativeElement.click();
  }

  selectMedia(media: ParamsMedia): void {

    if (!this.optionImg) {
      this.elementImg.mediaId = media.Ident.toString();
      this.elementImg.mediaPath = media.Path;
      this.elementImg.mediaType = media.Type;
    } else {
      this.elementImg.mediaOption = true;
      this.optionImg.mediaId = media.Ident.toString();
      this.optionImg.mediaPath = media.Path;
      this.optionImg.mediaType = media.Type;
    }

    this.closeModalMedia.nativeElement.click();
  }

  removeMedia(element: QuestElement, option: Option | null): void {
    if (!option) {
      element.mediaPath = '';
      element.mediaId = '';
      element.mediaType = '';
    } else {
      if (option) {
        option.mediaPath = '';
        option.mediaId = '';
        option.mediaType = '';

        if (element.options.filter((opt: Option) => opt.mediaId != null).length === 0) {
          element.mediaOption = false;
        }
      }
    }
  }
  //#endregion


  onChangeFilter(event: any, filter: QuestPropFilter): void {
    filter.propFilter = !filter.propFilter;
    this.nbFilter = this.questionnaire.filterBo.filter((r: QuestPropFilter) => r.propFilter == true).length;
  }


  manageCkEditorConfig() {
    let desc: any = this.indParam.Trad.Trads.find(label => label.Key === 'questionnaireDescription');
    desc = desc ? desc.Value : '';
    this.ckConfigDesc = {
      placeholder: desc,
      toolbar: ['bold', 'italic', 'underline', '|', 'fontColor', 'fontBackgroundColor', 'fontFamily', 'fontSize', 'alignment', '|', 'removeFormat', '|', 'indent', 'outdent', '|'],
      fontSize: { options: ['default', 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 22, 24, 26, 28, 36, 48, 50] },
      removePlugins: ['Title']
    }

    this.ckConfigMsgFin = {
      placeholder: 'Message de fin de questionnaire',
      toolbar: ['bold', 'italic', 'underline', '|', 'fontColor', 'fontBackgroundColor', 'fontFamily', 'fontSize', 'alignment', '|', 'removeFormat', '|', 'indent', 'outdent', '|'],
      fontSize: { options: ['default', 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 22, 24, 26, 28, 36, 48, 50] },
      removePlugins: ['Title']
    }



    let indice: any = this.indParam.Trad.Trads.find(label => label.Key === 'intituleIndice');
    indice = indice ? indice.Value : '';
    this.ckConfigIndice = {
      toolbar: ['bold', 'italic', 'underline', '|', 'fontColor', 'fontBackgroundColor', 'fontFamily', 'fontSize', 'alignment', '|', 'removeFormat', '|', 'indent', 'outdent', '|'],
      fontSize: { options: ['default', 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 22, 24, 26, 28, 36, 48, 50] },
      placeholder: indice,
      removePlugins: ['Title']
    }


    this.ckConfigCommentaire = {
      placeholder: 'Intitulé du commentaire',
      toolbar: ['bold', 'italic', 'underline', '|', 'fontColor', 'fontBackgroundColor', 'fontFamily', 'fontSize', 'alignment', '|', 'removeFormat', '|', 'indent', 'outdent', '|'],
      fontSize: { options: ['default', 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 22, 24, 26, 28, 36, 48, 50] },
      removePlugins: ['Title']
    }
  }

}

